// extracted by mini-css-extract-plugin
module.exports = {"main":"LargeCategoryTitle_main__6V5MA","title":"LargeCategoryTitle_title__7tAi_"};